export function flattenBlockMaterials(blocks = []) {
  return (blocks || []).flatMap((block) => {
    return (block.skills || []).flatMap((skill) => {
      const indicatorMaterials = (skill.indicators || []).flatMap(
        (indicator) => indicator.materials || []
      );

      return [...(skill.materials || []), ...indicatorMaterials];
    });
  });
}
